import { formatMoney } from '@shopify/theme-currency'
import { getSizedImageUrl } from '@shopify/theme-images'

export const money = (el, { expression }, { evaluateLater, effect }) => {
    const getValue = evaluateLater(expression)

    effect(() => {
        getValue(value => {
            el.textContent = formatMoney(value, Shopify.money_format)
        })
    })
}

export const imageTransform = (el, { expression }) => {
    el.src = getSizedImageUrl(el.src, expression)
}
